import { HttpErrorResponse } from "@angular/common/http";
import { ValidationError } from "src/app/api/models";
import { CustomTranslationService } from "../translation/custom-translation.service";

export class ErrorMsgHelper {

  static readonly MEDICAL_HISTORY_STOCK_ERROR_CODE = "909";
  static readonly USER_WRONG_PASSWORD  = "101";

  static handleError(translateSrv: CustomTranslationService, error: HttpErrorResponse): string | undefined {
    let serverError = this.parseError(error);
    if (serverError && serverError.length > 0) {
      const sError = serverError[0];
      if (sError.message) {
        return this.defineErrorMsg(translateSrv, sError);
      }
    }
    return undefined;
  }

  static parseError(error: HttpErrorResponse): ValidationError[] {
    if (error.error) {
      let serverError;
      try {
        serverError = JSON.parse(error.error);
      } catch {
        serverError = error.error;
      }
      if (serverError && Array.isArray(serverError)) {
        return serverError as ValidationError[];
      }
    }
    return [];
  }

  /**
  * Constructs error message with given params.
  * @param sError error key
  * @returns error message
  */
  static defineErrorMsg(translateSrv: CustomTranslationService, sError: ValidationError): string | undefined {
    let errorMsg = sError.message;
    if (sError.message) {
      errorMsg = translateSrv.instant(sError.message);

      if (sError.params) {
        for (const x in sError.params) {
          errorMsg = errorMsg?.replace('{}', sError.params[x]);
        }
      }
      if (sError.errorCode) {
        errorMsg += ' (Code: ' + sError.errorCode + ')';
      }
    }

    return errorMsg;
  }

}
